// extracted by mini-css-extract-plugin
export default {"component":"CogButton_component__xd5rD","button":"CogButton_button__0jeL-"};